import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useLabel } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const CommissionsBlock = ({ operationType, paymentId }) => {
  const [DOMPurify, installDOMPurify] = useState({});
  const processingTimeLabelKey = `pmid_${paymentId}_${operationType.toLowerCase()}_processing_time`;
  const feeLabelKey = `pmid_${paymentId}_${operationType.toLowerCase()}_fee`;
  const processingTimeLabelValue = useLabel(processingTimeLabelKey);
  const feeLabelValue = useLabel(feeLabelKey);
  const processingTime = processingTimeLabelValue === `#${processingTimeLabelKey}` ? undefined : processingTimeLabelValue;
  const fee = feeLabelValue === `#${feeLabelKey}` ? undefined : feeLabelValue;

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      installDOMPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (!DOMPurify.sanitize || (!processingTime && !fee)) return null;

  return (
    <div className="commissions-block">
      {processingTime && (
        <div className="commissions-field">
          <div className="commissions-field-name">
            <Icon height={16} name="time" width={16} />
            <Label message="processing_time" />
          </div>
          <div
            className="commissions-field-value"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(processingTime) }}
          />
        </div>
      )}
      {fee && (
        <div className="commissions-field">
          <div className="commissions-field-name">
            <Icon height={16} name="max-bonus" width={16} />
            <Label message="fee" />
          </div>
          <div
            className="commissions-field-value"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fee) }}
          />
        </div>
      )}
    </div>
  );
};

CommissionsBlock.propTypes = {
  operationType: PropTypes.string.isRequired,
  paymentId: PropTypes.string.isRequired,
};

export default CommissionsBlock;
